import React from "react";
import sum1 from "../../assets/sum-1.svg";
import sum2 from "../../assets/sum-2.svg";
import sum3 from "../../assets/sum-3.svg";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";

const VoucherSummary = ({
  summaryActiveVoucher,
  summaryPurchasedVoucher,
  summaryRedeemedVoucher,
}) => {
  return (
    <>
      <p className="page-maintitle">Voucher Summary</p>
      <div className="summary-main mt-3">
        <div className="summary-inner pt-3">
          <div className="image-div"><Image loading="lazy" src={sum1} /></div>
          <div className="summary-right ml-2">
            <p className="sum-text1">Total Purchased Vouchers</p>
            <p className="sum-text2">{summaryPurchasedVoucher == "" ? 0 : summaryPurchasedVoucher}</p>
          </div>
        </div>
        <div className="summary-inner pt-3">
        <div className="image-div"><Image loading="lazy" src={sum2} /></div>
          <div className="summary-right ml-2">
            <p className="sum-text1">Total Redeemed Vouchers</p>
            <p className="sum-text2">{summaryRedeemedVoucher == "" ? 0:summaryRedeemedVoucher}</p>
          </div>
        </div>
        <div className="summary-inner pt-3">
        <div className="image-div"><Image loading="lazy" src={sum3} /></div>
          <div className="summary-right ml-2">
            <p className="sum-text1">Total Active Vouchers</p>
            <p className="sum-text2">{summaryActiveVoucher == "" ? 0 : summaryActiveVoucher}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoucherSummary;
